import KmTabPane from '../tabs/tab-pane.vue'
KmTabPane.install = function (vue) {
  vue.component(KmTabPane.name, KmTabPane)
}
export default KmTabPane



// WEBPACK FOOTER //
// ./src/ui/components/tab-pane/index.js